import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        // console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        // console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const adminDashboardCheckMarquee = createAccountAsyncThunk(
  "post",
  "adminDashboardCheckMarquee",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/candidate_get_checks_count/"
);

export const adminDashboardTatData = createAccountAsyncThunk(
  "post",
  "adminDashboardTatData",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/candidate_get_checks_tat_count/"
);

export const getChecksList = createAccountAsyncThunk(
  "post",
  "getChecksList",
  "application/json",
  "valiantinfo_admin/apicheck/get_api_client/"
);

export const CheckInteractivity = createAccountAsyncThunk(
  "post",
  "CheckInteractivity",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/candidate_get_checks_code_details/"
);

export const GetStatusCounts = createAccountAsyncThunk(
  "post",
  "GetStatusCounts",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/fetch_candidate_statuscount_amountspent/"
);

export const GetAccessData = createAccountAsyncThunk(
  "post",
  "GetAccessData",
  "application/json",
  "valiantinfo_admin/client_vendor_service/client_access_control_list/"
);

export const GetPreOnboardingCandidatesList = createAccountAsyncThunk(
  "post",
  "GetPreOnboardingCandidatesList",
  "application/json",
  "valiantinfo_admin/admin_dashboard_service/fetch_pre_on_boarding_candidate_details/"
);